<template>
  <!-- Contact Section start -->
  <section id="contact" class="contact">
    <div class="contact-decor">
      <div class="contact-circle1">
        
      </div>
      <div class="contact-circle2">
        
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-8 col-sm-12">
          <div class="contact-us">
            <div class="w-100">
              <h2 class="title"><span>contactez</span> nous</h2>
              <b-form
                id="myform"
                class="theme-form"
                method="post"
                @submit.prevent="recaptcha"
              >
                <div class="row">
                  <div class="col-sm-12 col-md-6 md-fgrup-margin">
                    <b-form-group
                      id="input-group-1"
                      class="mb-0 mt-0"
                      label="Prénom : "
                      label-for="input-1"
                    >
                      <b-form-input
                        id="input-1"
                        class="form-control"
                        v-model="form.prenom"
                        :state="isPnmStateValid"
                        :formatter="fnameFormatter"
                        :disabled="busy"
                        placeholder="Votre prénom"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <b-form-group
                      id="input-group-2"
                      class="mb-0 mt-0"
                      label="Nom :"
                      label-for="input-2"
                    >
                      <b-form-input
                        id="input-2"
                        class="form-control"
                        v-model="form.nomfam"
                        :state="isNmfStateValid"
                        :formatter="lnameFormatter"
                        :disabled="busy"
                        placeholder="Votre nom de famille"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-6 md-fgrup-margin">
                    <b-form-group
                      id="input-group-3"
                      class="mb-0"
                      label="E-mail :"
                      label-for="input-3"
                    >
                      <b-form-input
                        id="input-3"
                        class="form-control"
                        v-model="form.email"
                        type="email"
                        :state="isMailStateValid"
                        :formatter="emailFormatter"
                        placeholder="Votre adresse mail"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <b-form-group
                      id="input-group-4"
                      class="mb-0"
                      label="N° de téléphone :"
                      label-for="input-4"
                    >
                      <b-form-input
                        id="input-4"
                        class="form-control"
                        v-model="form.tel"
                        type="tel"
                        min="10"
                        max="16"
                        :state="isTelStateValid"
                        :formatter="phoneFormatter"
                        :disabled="busy"
                        placeholder="Votre n° de tél."
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <b-form-group
                  id="input-group-5"
                  label="Message :"
                  label-for="message"
                  :invalid-feedback="textLenght"
                  :valid-feedback="textLenght"
                >
                  <b-form-textarea
                    id="message"
                    class="form-control"
                    v-model="form.msg"
                    rows="4"
                    :state="isTextStateValid"
                    :formatter="txtFormatter"
                    :disabled="busy"
                    placeholder="Votre message"
                  ></b-form-textarea>
                </b-form-group>
                <div class="d-none">
                  <b-form-checkbox
                    id="input-0"
                    class="form-control"
                    v-model="form.box"
                    value="me"
                    :disabled="busy"
                    >Check me out</b-form-checkbox
                  >
                </div>
                <div class="form-button">
                  <b-button
                    ref="submit"
                    type="submit"
                    :disabled="busy"
                    variant="primary"
                    class="btn btn-custom theme-color"
                    >Envoyer</b-button
                  >
                </div>
              </b-form>
              <b-overlay
                :show="busy"
                no-wrap
                @shown="onShown"
                @hidden="onHidden"
              >
                <template #overlay v-if="busy">
                  <div
                    v-if="processing"
                    ref="dialog"
                    role="dialog"
                    class="text-center p-4 bg-primary text-light rounded"
                  >
                    <b-icon
                      icon="envelope"
                      animation="throb"
                      font-scale="4"
                    ></b-icon>
                    <div class="mt-3 mb-3">Envoi du message...</div>
                  </div>
                  <div
                    v-else-if="ajax_response"
                    ref="dialog"
                    tabindex="-1"
                    role="dialog"
                    aria-modal="false"
                    aria-labelledby="form-response-label"
                    class="text-center p-3"
                  >
                    <div>
                      <h3 :class="responseDataArg">
                        <b-icon
                          :icon="responseDataIco"
                          :variant="responseDataArg"
                          scale="1.5"
                          shift-h="-8"
                        ></b-icon>
                        {{ titleAjaxResponse }}
                      </h3>
                    </div>
                    <div>
                      <span v-for="val in bodyAjaxResponse" class="mb-0"
                        >{{ val }}<br
                      /></span>
                    </div>
                    <b-button class="mt-3 success" style="color:white" @click="onReset"
                      >Fermer</b-button
                    >
                  </div>
                  <div
                    v-else
                    ref="dialog"
                    tabindex="-2"
                    role="dialog"
                    aria-modal="false"
                    aria-labelledby="form-confirm-label"
                    class="text-center p-3"
                  >
                    <h3 class="danger">
                      <b-icon
                        icon="exclamation-triangle-fill"
                        variant="danger"
                        scale="1.5"
                        shift-h="-8"
                      ></b-icon>
                      Attention !
                    </h3>
                    <span v-if="missmatches.length">Veuillez remplir tous les champs<br /></span>
                    <b-button class="mt-3" style="color:white" @click="onCancel"
                      >Fermer</b-button
                    >
                  </div>
                </template>
              </b-overlay>
            </div>
          </div>
        </div>
        <div class="col-lg-4 d-medium-none-lg">
          <div class="contact-right">
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Contact Section End -->
</template>

<script>
const axios = require("axios");

export default {
  name: "Contact_us",
  data() {
    return {
      form: {
        prenom: "",
        nomfam: "",
        email: "",
        tel: "",
        msg: "",
        box: [],
      },
      missmatches: [],
      busy: false,
      processing: false,
      ajax_response: false,
      ajax_state: null,
      ret_var: "",
      ret_ico: "",
      data_title: "",
      data_response: [],
    };
  },
  computed: {
    isPnmStateValid() {
      if (this.form.prenom) {
        return this.isValidPnm();
      }
      return null;
    },
    isNmfStateValid() {
      if (this.form.nomfam) {
        return this.isValidNmf();
      }
      return null;
    },
    isMailStateValid() {
      if (this.form.email) {
        return this.isValidEmail();
      }
      return null;
    },
    isTelStateValid() {
      if (this.form.tel) {
        return this.isValidPhone();
      }
      return null;
    },
    isTextStateValid() {
      if (this.form.msg) {
        return this.isValidMsg();
      }
      return null;
    },
    textLenght() {
      return this.form.msg.length + "/2000";
    },
    responseDataArg() {
      return this.isResponseDataArg();
    },
    responseDataIco() {
      return this.isResponseDataIco();
    },
    titleAjaxResponse() {
      if (this.ajax_response === true) {
        return this.data_title;
      } else {
        return null;
      }
    },
    bodyAjaxResponse() {
      if (this.ajax_response === true) {
        return this.data_response;
      } else {
        return null;
      }
    },
  },
  methods: {
    // formatters
    fnameFormatter(value) {
      var output = value.replace(/^[ \-']*/g, "");
      output = output.replace(
        /[^A-Za-záàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ \-']+/g,
        ""
      );
      output = output.replace(/[ ]{2,}/g, " ");
      output = output.replace(/[-]{2,}/g, "-");
      output = output.replace(/[']{2,}/g, "'");
      var spart = output.split(" ");
      for (var i = 0; i < spart.length; i++) {
        var j = spart[i].charAt(0).toUpperCase();
        spart[i] = j + spart[i].substr(1);
      }
      output = spart.join(" ");
      return output;
    },
    lnameFormatter(value) {
      var output = value.replace(/^[ \-']*/g, "");
      output = output.replace(
        /[^A-Za-záàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ \-']+/g,
        ""
      );
      output = output.replace(/[ ]{2,}/g, " ");
      output = output.replace(/[-]{2,}/g, "-");
      output = output.replace(/[']{2,}/g, "'");
      output = output.toUpperCase();
      return output;
    },
    emailFormatter(value) {
      return value.replace(/[^A-Za-z0-9\-_@.]+/g, "").toLowerCase();
    },
    phoneFormatter(value) {
      var output = value.replace(/^[ ]*/g, "");
      output = output.replace(/[^+\d ]+/g, "");
      output = output.replace(/[+]{2,}/g, "+");
      output = output.replace(/[ ]{2,}/g, " ");
      output = output.replace(/(\d\+)(?=\d| |\+)/g, "");
      output = output.replace(/( \+)(?=\d| |\+)/g, " ");
      return output;
    },
    txtFormatter(value) {
      var output = value.replace(/^(\s)*/g, "");
      output = output.replace(
        /[^A-Za-z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ \r\n\-'°()#*,;:?!.]+/g,
        ""
      );
      output = output.replace(/[ ]{2,}/g, " ");
      output = output.replace(/[\r]{2,}/g, "\r");
      output = output.replace(/[\n]{2,}/g, "\n");
      output = output.replace(/[\s]{2,}/g, " ");
      output = output.replace(/[-]{2,}/g, "-");
      output = output.replace(/[']{2,}/g, "'");
      output = output.replace(/[°]{2,}/g, "°");
      output = output.replace(/[#]{2,}/g, "#");
      output = output.replace(/[*]{2,}/g, "*");
      output = output.replace(/[,]{2,}/g, ",");
      output = output.replace(/[;]{2,}/g, ";");
      output = output.replace(/[:]{2,}/g, ":");
      output = output.replace(/[?]{2,}/g, "?");
      output = output.replace(/[!]{2,}/g, "!");
      output = output.replace(/[.]{2,}/g, ".");
      output = output.substring(0, 2000);
      return output;
    },
    // State validators
    isValidPnm() {
      return this.form.prenom.trim().length > 1;
    },
    isValidNmf() {
      return this.form.nomfam.trim().length > 1;
    },
    isValidEmail() {
      return this.form.email.trim().length > 2;
    },
    isValidPhone() {
      return this.form.tel.trim().length > 2;
    },
    isValidMsg() {
      return this.form.msg.trim().length > 9;
    },
    // response handlers
    isResponseDataArg() {
      if (this.ajax_state === true) {
        this.ret_var = "success";
      } else if (this.ajax_state === false) {
        this.ret_var = "danger";
      } else {
        this.ret_var = "";
      }
      return this.ret_var;
    },
    isResponseDataIco() {
      if (this.ajax_state === true) {
        this.ret_ico = "check-circle-fill";
      } else if (this.ajax_state === false) {
        this.ret_ico = "exclamation-triangle-fill";
      } else {
        this.ret_ico = "";
      }
      return this.ret_ico;
    },
    // processing handlers
    onShown() {
      // Focus the dialog prompt
      this.$refs.dialog.focus();
    },
    onHidden() {
      // In this case, we return focus to the submit button
      // You may need to alter this based on your application requirements
      this.$refs.submit.focus();
    },
    onCancel() {
      this.busy = false;
      console.log("oncancel");
      console.log(this.busy);
    },
    onReset() {
      this.busy = false;
      this.ajax_response = false;
      this.ajax_state = null;
      window.location.reload();
      /*    console.log('onreset')
            console.log(this.busy)
            console.log(this.ajax_response)
            console.log(this.ajax_state)*/
    },
    async recaptcha() {
     
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha("submit");
      let obj = new FormData();

      obj.append('response', token)
      axios.post('php/public/verifytoken.php', obj).then(resp => {
          if (resp.data && resp.data.success === true && resp.data.score > 0.5)
           this.checkForm();
      }).catch(error => {
        console.log(error)
      })
    
    },
    checkForm() {
      this.missmatches = [];
      if (!this.form.prenom) {
        this.missmatches.push("Saisissez votre prénom.");
      } else if (this.form.prenom.length < 2) {
        this.missmatches.push("Votre prénom est trop court.");
      }
      if (!this.form.nomfam) {
        this.missmatches.push("Saisissez votre nom de famille.");
      } else if (this.form.nomfam.length < 2) {
        this.missmatches.push("Votre nom de famille est trop court.");
      }
      if (!this.form.email) {
        this.missmatches.push("Saisissez votre adresse mail.");
      } else if (!this.validEmail(this.form.email)) {
        this.missmatches.push("L'adresse mail saisie n'est pas valide.");
      }
      if (this.form.tel) {
        if (!this.validPhone(this.form.tel)) {
          this.missmatches.push(
            "Le numéro de téléphone saisi n'est pas valide."
          );
        }
      }
      if (!this.form.msg || this.form.msg.trim().length === 0) {
        this.missmatches.push("Il n'y a pas de message.");
      } else if (this.form.msg.length < 10) {
        this.missmatches.push("Le message est trop court.");
      }

      if (this.missmatches.length) {
        this.busy = true;
        this.processing = false;
        this.ajax_response = false;
      } else {
        let currentObj = this;
        currentObj.busy = true;
        currentObj.processing = true;
        var formData = currentObj.toFormData(currentObj.form);
        axios
          .post("php/public/entry.php", formData)
          .then((response) => {
            currentObj.processing = false;
            currentObj.ajax_response = true;
            currentObj.data_response = [];
            if (response.data.err_msg) {
              currentObj.ajax_state = false;
              currentObj.data_title = "Attention !";
              Object.keys(response.data.err_field).forEach(function (k) {
                currentObj.form[response.data.err_field[k]] = null;
              });
              Object.keys(response.data.err_msg).forEach(function (k) {
                currentObj.data_response.push(response.data.err_msg[k]);
              });
            }
            // else if (response.data.err_statut) {
            //     currentObj.ajax_state = false
            //     currentObj.data_title = 'Erreur !'
            //     currentObj.data_response.push('Nous n\'avons pas pu enregistrer votre demande.')
            //     currentObj.data_response.push('Veuillez essayer à nouveau dans quelques instants.')
            // }
            else if (response.data.mails.err_gb) {
              currentObj.ajax_state = false;
              currentObj.data_title = "Attention !";
              currentObj.data_response.push("Votre demande a été enregistrée.");
              currentObj.data_response.push(
                "Cependant nous rencontrons quelques difficultés avec le service d'envoi de mails."
              );
              currentObj.data_response.push(
                "Veuillez nous contacter en l'abscence de réponse dans les 48h."
              );
            } else if (
              response.data.mails.notif &&
              response.data.mails.confirm
            ) {
              currentObj.ajax_state = true;
              currentObj.data_title = "Demande enregistrée !";
              currentObj.form = null;
              if (
                response.data.mails.notif.noti_arg === "OK" &&
                response.data.mails.confirm.cofi_arg === "OK"
              ) {
                currentObj.data_response.push(
                  "Votre demande a été envoyée à nos spécialistes et sera traitée dans quelques instants."
                );
              } else if (
                response.data.mails.notif.noti_arg === "Erreur" &&
                response.data.mails.confirm.cofi_arg === "OK"
              ) {
                currentObj.data_response.push(
                  "Cependant notre boite mail est pleine... Désolé !"
                );
                currentObj.data_response.push(
                  "Veuillez nous contacter à nouveau en l'abscence de réponse dans les 48h."
                );
              } else if (
                response.data.mails.notif.noti_arg === "OK" &&
                response.data.mails.confirm.cofi_arg === "Erreur"
              ) {
                currentObj.data_response.push(
                  "Cependant nous n'arrivons pas à vous envoyer le mail de confirmation."
                );
                currentObj.data_response.push(
                  "Veuillez nous contacter à nouveau avec une autre adresse mail en l'abscence de réponse dans les 48h."
                );
              } else {
                currentObj.data_response.push(
                  "Cependant nous rencontrons quelques difficultés avec le service d'envoi de mails."
                );
                currentObj.data_response.push(
                  "Veuillez nous contacter en l'abscence de réponse dans les 48h."
                );
              }
            } else {
              currentObj.ajax_state = false;
              currentObj.data_title = "Erreur !";
              currentObj.data_response.push(
                "Nous rencontrons une erreur inconnue."
              );
              currentObj.data_response.push(
                "Veuillez essayer à nouveau dans quelques instants."
              );
            }
          })
          .catch((error) => {
            currentObj.processing = false;
            currentObj.ajax_response = true;
            currentObj.data_response = [];
            currentObj.data_title = "Erreur !";
            currentObj.data_response.push("Une erreur est survenue.");
            currentObj.data_response.push(
              "Erreur : " + error.response.data.message
            );
          });
      }
    },
    toFormData(obj) {
      var formData = new FormData();
      for (var key in obj) {
        formData.append(key, obj[key]);
      }
      return formData;
    },
    validEmail() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/;
      return this.form.email.match(re);
    },
    validPhone() {
      var re = /^(0|\+)?[1-8][ ]?([\d]{2,3}[ ]?){4,6}$/;
      return this.form.tel.match(re);
    },
  },
};
</script>
<style scoped>
input, textarea{
  font-size:15px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/contact_us.vue